var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%"},style:('height:' + _vm.height +'px'),attrs:{"title":"print_frame","name":"print_frame","id":"blob-src-test"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }